import React, { useState, useEffect } from "react";
import axios from "axios";import "./faq.css";
import "./faq.scss";
import right_image from "../../assets/right.png";
import { TbCircleArrowDownFilled } from "react-icons/tb";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; 
import "swiper/css/autoplay"; 
import { Autoplay } from "swiper/modules";
import c1 from "../../assets/c1.jpg";
import c2 from "../../assets/c2.jpg";
import c3 from "../../assets/c3.jpg";
import c4 from "../../assets/c4.jpg";
import traveler from "../../assets/traveler.png"; // 👈 ضع هنا صورة الشخص

const images = [c1, c2, c3, c4, c1, c2, c3]; // كده 7 صور


const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  // 🔹 Fetch FAQs from API
  useEffect(() => {
    axios.get("https://admin.mythsegypttours.com/api/faqs")
      .then((res) => setFaqs(res.data))
      .catch((err) => console.error("Error fetching FAQs:", err));
  }, []);
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="main-faq container section">
      <div className="secTitle text-center mb-5">
        <span>FAQ</span>
        <h2 className="title">Check Asked Questions</h2>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit
          reprehenderit reiciendis neque tempore itaque dolorem unde, quasi sint
          voluptates sequi amet aut quisquam excepturi expedita asperiores?
          Doloremque nihil fuga excepturi.
        </p>
      </div>

      <div className="faq-wrapper">
        <div className="faq-left">
          {faqs.map((faq, index) => (
            <div
              key={faq.id}
              className={`faq-card ${activeIndex === index ? "active" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className={`arrow ${activeIndex === index ? "rotate" : ""}`}>
                  <TbCircleArrowDownFilled className="arrow-icon" />
                </span>
              </div>
              {activeIndex === index && <p className="faq-answer">{faq.answer}</p>}
            </div>
          ))}
        </div>
        {/* العمود الثاني: الصورة */}
        <div className="faq-right">
          <img src={right_image} alt="FAQ Illustration" />
        </div>
      </div>

       <div className="secTitle">
        <span>Partners</span>
        <p>
          Trusted By 200+ Global Brands
        </p>
      </div>

<div className="carousel-container">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={7} /* عدد الصور اللي يظهروا في نفس الوقت */
        loop={true}
        autoplay={{
          delay: 2000, // كل 2 ثانية يتحرك
          disableOnInteraction: false,
        }}
        speed={800} // سرعة الانتقال
      >
        {images.map((src, index) => (
          <SwiperSlide key={index}>
            <div className="carousel-image-box">
              <img src={src} alt={`Slide ${index}`} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>

     <div className="subscribe-box">
      {/* صورة */}
      

      {/* النص + الفورم */}
      <div className="subscribe-content">
        <div className="subscribe-left">
        <img src={traveler} alt="Traveler" />
      </div>
        <h3>
          Sign Up For Exclusive Deals And See <br /> Price Drops!
        </h3>

        <form className="subscribe-form">
          <input type="email" placeholder="Your Email" required />
          <button type="submit">Subscribe</button>
        </form>
      </div>
    </div>
    </section>
  );
};

export default FAQ;
